import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function MemberEventCards() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("memberEventCards.title")}</h1>
      <p>
        <Trans i18nKey="memberEventCards.intro" components={[<code key="0" />]} />
      </p>

      <CodeBlock title="welcomeImage()">{`import { welcomeImage } from "kira-arts";

const buffer = await welcomeImage(member.id, guild.name, {
  guildId: guild.id,
  useRoleColor: true,
  memberCount: guild.memberCount,
  showBadges: true,
});`}</CodeBlock>

      <CodeBlock title="leaveImage()">{`import { leaveImage } from "kira-arts";

const buffer = await leaveImage(member.id, guild.name, {
  guildId: guild.id,
  useRoleColor: true,
});`}</CodeBlock>

      <h2>{t("memberEventCards.optionsTitle")}</h2>
      <CodeBlock title="MemberEventOptions">{`message?: string;
secondaryMessage?: string;
memberCount?: number;
layout?: "centered" | "banner";
size?: "compact" | "standard" | "wide";
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
showDate?: boolean;
showBadges?: boolean;
maxBadges?: number;
usernameEffect?: "shadow" | "glow";
guildId?: string;
theme?: KiraThemeName;
animated?: boolean;
confetti?: boolean;
gifSeconds?: number;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="memberEventCards.colorNote"
          components={[
            <code key="0" />,
            <code key="1" />,
            <code key="2" />,
            <code key="3" />,
            <code key="4" />,
          ]}
        />
      </p>

      <h2>{t("memberEventCards.layoutTitle")}</h2>
      <p>
        <Trans
          i18nKey="memberEventCards.layoutIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <CodeBlock title="banner layout">{`const buffer = await welcomeImage(member.id, guild.name, {
  guildId: guild.id,
  layout: "banner",
  size: "wide",
  secondaryMessage: "{username} joined {server}",
});`}</CodeBlock>

      <p>
        <Trans
          i18nKey="memberEventCards.sizeIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <h2>{t("memberEventCards.messageTitle")}</h2>
      <p>
        <Trans
          i18nKey="memberEventCards.messageIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <CodeBlock title="custom message">{`const buffer = await welcomeImage(member.id, guild.name, {
  guildId: guild.id,
  message: "{username} just landed in {server} \u2728",
});`}</CodeBlock>

      <h2>{t("memberEventCards.colorsTitle")}</h2>
      <p>
        <Trans
          i18nKey="memberEventCards.colorsIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <h2>{t("memberEventCards.effectsTitle")}</h2>
      <p>
        <Trans
          i18nKey="memberEventCards.effectsIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <h2>{t("memberEventCards.animatedTitle")}</h2>
      <p>
        <Trans
          i18nKey="memberEventCards.animatedIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <CodeBlock title="animated GIF">{`import { welcomeImage, toAttachment } from "kira-arts";

const gif = await welcomeImage(member.id, guild.name, {
  guildId: guild.id,
  layout: "banner",
  animated: true,
  confetti: true,
  gifSeconds: 6,
});

const attachment = toAttachment(gif, { name: "welcome", extension: "gif" });`}</CodeBlock>

      <p>
        <Trans
          i18nKey="memberEventCards.confettiIntro"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="memberEventCards.gifSecondsIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="memberEventCards.autoAnimateIntro"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>
    </article>
  );
}
